<template lang="pug" src="./create-dialog.pug"> </template>
<style lang="scss" src="./create-dialog.scss" scoped> </style>

<script>

import reasonEditor from '@/components/reason-editor';

export default {
    components: {
        'v-reason-editor': reasonEditor
    },
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        reason: {
            types: [],
            name: null
        }
    }),
    computed: {
        createDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        async createReason() {
            if (this.$refs.reasonEditor.$v.$invalid) {
                this.$refs.reasonEditor.$v.$touch();
            } else {
                await this.$store.dispatch('photoReasons/createRequestReason', this.reason);
                this.cancelCreateReason();
            }
        },

        resetData() {
            this.$refs.reasonEditor.resetData();
        },

        cancelCreateReason() {
            this.createDialog = false;
            this.resetData();
        }
    }
};
</script>
